module.exports = __webpack_public_path__ + "905b62cc9fd8723d843817d642b00ec2.png";